import { render, staticRenderFns } from "./Recognised.vue?vue&type=template&id=afd32110&scoped=true"
import script from "./Recognised.vue?vue&type=script&lang=js"
export * from "./Recognised.vue?vue&type=script&lang=js"
import style0 from "./Recognised.vue?vue&type=style&index=0&id=afd32110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd32110",
  null
  
)

export default component.exports